import { Text, View } from '@react-pdf/renderer';

import { usePDFContext } from '../../../PDFProvider';
import { styles } from '../styles';

export function CustomerContact() {
  const { customer } = usePDFContext();

  const { email, phone } = customer;

  if (!email && !phone) {
    return null;
  }

  return (
    <View style={styles.section}>
      {email ? <Text>{email}</Text> : null}
      {phone ? <Text>{phone}</Text> : null}
    </View>
  );
}
